/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconInfoSquareRounded = createReactComponent(
  "info-square-rounded",
  "IconInfoSquareRounded",
  [
    ["path", { d: "M12 9h.01", key: "svg-0" }],
    ["path", { d: "M11 12h1v4h1", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconInfoSquareRounded as default };
//# sourceMappingURL=IconInfoSquareRounded.js.map
